/**
 * 开发者离线调试与环境变量清洗工具
 * @description 提供前端缓存清理支持
 */

import { STORAGE_KEYS } from '@/constants'

const authStorageKeys = [
  STORAGE_KEYS.USER_STORE_V1,
  STORAGE_KEYS.USER_STORE_V2,
  STORAGE_KEYS.ADMIN_TOKEN,
  STORAGE_KEYS.USER_TOKEN,
  STORAGE_KEYS.LEGACY_TOKEN,
  STORAGE_KEYS.LEGACY_USER_INFO,
  STORAGE_KEYS.LEGACY_REFRESH_TOKEN,
]

/**
 * 清除所有系统可能残留的状态
 */
export function cleanAllStorage(): void {
  try {
    // 1. 清除明确知道的遗留键（保障机制）
    authStorageKeys.forEach((key) => {
      localStorage.removeItem(key)
      sessionStorage.removeItem(key)
    })

    // 2. 彻底清空所有 Storage (开发者强制清洗)
    localStorage.clear()
    sessionStorage.clear()

    console.warn('🧹 [Mech3D DataClean] 所有 LocalStorage 与 SessionStorage 已被彻底清空！')
  }
  catch (error) {
    console.error('🧹 [Mech3D DataClean] 清理存储时发生错误:', error)
  }
}

/**
 * 选择性清理：仅清除认证相关的缓存状态
 * @description 适用于退出登录或 401 拦截等场景，保留用户偏好设置（如"记住我"）等非敏感数据
 */
export function cleanAuthStorage(): void {
  try {
    authStorageKeys.forEach((key) => {
      localStorage.removeItem(key)
      sessionStorage.removeItem(key)
    })

    console.warn('🧹 [Mech3D DataClean] 认证相关缓存已清除！')
  }
  catch (error) {
    console.error('🧹 [Mech3D DataClean] 选择性清理存储时发生错误:', error)
  }
}

/**
 * 挂载到全局 window 对象，供开发者在控制台随时调用
 */
export function setupDevTools(): void {
  if (import.meta.env.DEV) {
    // @ts-expect-error 扩展 window 对象
    window.__MECH3D_CLEAN_ALL__ = () => {
      cleanAllStorage()
      console.warn('🔄 [Mech3D DataClean] [全量清理] 即将刷新页面以应用干净状态...')
      setTimeout(() => {
        // 存储全量清理后需硬刷新以重置全部应用状态（Pinia Store + 内存缓存）
        window.location.href = '/auth/login'
      }, 500)
    }

    // @ts-expect-error 扩展 window 对象
    window.__MECH3D_CLEAN_AUTH__ = () => {
      cleanAuthStorage()
      console.warn('🔄 [Mech3D DataClean] [认证清理] 即将刷新页面以应用干净状态...')
      setTimeout(() => {
        // 认证状态清理后需硬刷新以确保前端完全重置
        window.location.href = '/auth/login'
      }, 500)
    }

    console.warn('🛠️ [DevTools] 已挂载全局清理函数: window.__MECH3D_CLEAN_ALL__() 和 window.__MECH3D_CLEAN_AUTH__()')
  }
}
